import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute("/_authenticated/$tenantSlug/_layout/affiliate/_layout")({
    component: AffiliateLayout,
    loader: ({ context: { t } }) => {
        return {
            breadcrumb: t("pages.affiliate.title"),
        };
    },
});

function AffiliateLayout() {
    return <Outlet />;
}
